import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useTheme } from '@repo/shared';
import moment from 'moment';
// Import
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";
import EventDataService from "../../services/event/EventService";
import EventAttendanceDataService from "../../services/event/EventAttendanceService";
import StudentDataService from "../../services/student/StudentService";
import LessonDataService from "../../services/class/LessonService";

import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import "react-datepicker/dist/react-datepicker.css";

const EventAttendance = props => {
  const { id } = useParams(); const history = useHistory(); const initialAttendanceState = EventAttendanceDataService.initialiseNewAttendance();
  const [currentAttendances, setCurrentAttendances] = useState(initialAttendanceState);
  const [students, setStudents] = useState([]);
  const [currentEvent, setCurrentEvent] = useState({});
  const [attendanceGrid, setAttendanceGrid] = useState([]);
  const [dateHeaders, setDateHeaders] = useState([]);
  const [savingNotes, setSavingNotes] = useState(false);
  const [loading, setLoading] = useState(true);

  const { appTheme } = useTheme();
  useEffect(() => {
    document.title = `${appTheme?.appName} - Event Attendance`;
    fetchData();
  }, [id]);

  const fetchData = async () => {
    try {
    const event = await EventDataService.get(id);
    setCurrentEvent(event);

    const lessons = await LessonDataService.getLessonsForEvent(id);

    const incomingDateHeaders = lessons
      .sort((a, b) => moment(a.eventDate).diff(moment(b.eventDate)))
      .map((l, i) => {
        return { title: moment(l.eventDate).format('DD MMM'), editable: true, lesson: l }
      });
    setDateHeaders(incomingDateHeaders);

    const attendances = await EventAttendanceDataService.getForEvent(event.id);
    console.log(attendances);
    setCurrentAttendances(attendances);

    const studentsForEvent = await StudentDataService.getAllForEvent(event.id);
    const attendanceGrid = generateAttendanceGrid({ attendances, dates: event.dates, studentsForEvent });

    setAttendanceGrid(attendanceGrid);
    setStudents(studentsForEvent);
    } catch (error) {
      console.error('Error fetching event attendance data:', error);
    } finally {
      setLoading(false);
    }
  };

  const generateAttendanceGrid = ({ attendances, dates, studentsForEvent }) => {
    //might not need this

    //columns headers = dates
    //row headers = students
    //cells = attendences[date][student] || empty
    const grid = {};
    studentsForEvent.forEach(student => {
      const studentRow = {};
      grid[student.id] = studentRow;
      dates.forEach(date => {
        studentRow[date.getTime()] = {};

        //Here we need to lookup in attendances to see if we have an entry
        const found = attendances.find(attendance => attendance.studentId === student.id && attendance.eventDate.getTime() === date.getTime());
        studentRow[date.getTime()].attendance = found ? found.attendance : null;
      });
    });

    return grid;
  };

  const saveNotes = async () => {
    setSavingNotes(true);
    try {
      const savedNotes = await EventDataService.saveNotes(currentEvent.id, currentEvent.notes);
      alert('Notes saved');
      setSavingNotes(false);
    } catch (error) {
      console.error('Error saving notes:', error);
      setSavingNotes(false);
    }
  }

  const renderStudentAttendance = (student, index) => {
    return (
      <tr>
        {false && <td className="attendanceIndexColumn">
          <span className='minorText'>{index}</span>
        </td>}
        <td className="attendanceNameColumn">
          <div>
            <div>
              <span className='majorText'>{student.firstName} {student.lastName}</span>
            </div>
            <div>
              <span className='minorText'>{student.year} {student.className}</span>
            </div>
            <div>
              <span className='minorText'>{student.notes}</span>
            </div>
          </div>
        </td>
        {dateHeaders.map(dateHeader => {
          const attendanceDate = new Date(dateHeader.lesson.eventDate);
          const studentRow = attendanceGrid[student.id];
          const cell = studentRow[attendanceDate.getTime()];

          return <td className={'attendanceCheckBox'}>{cell?.attendance ? cell?.attendance : ''}</td>

        })}
      </tr>
    )
  };

  const renderBody = () => {
    return (
      <>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
            <div style={{ textAlign: 'center' }}>
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <p style={{ marginTop: '10px' }}>Loading Attendance data...</p>
            </div>
          </div>
        ) : (
          <>
            <div className="row">
              <div className="col-sm">
                <h2>{currentEvent.title} {students?.length ? `(${students.length} Students)` : ''}</h2>
                {currentEvent.location}
              </div>
              <div className="col-sm">
              </div>
              <div className="col-sm">
                <h2>{currentEvent.teacher}</h2>
              </div>
            </div>
            <div style={{ margin: 10, width: '80%' }}>
              <div className="form-group">
                <label htmlFor="notes">Notes</label>
                <textarea
                  style={{ height: 100 }}
                  type="text"
                  className="form-control"
                  id="notes"
                  name="notes"
                  value={currentEvent.notes || ''}
                  onChange={event => setCurrentEvent({ ...currentEvent, notes: event.target.value })}
                />
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={saveNotes}
                  disabled={savingNotes}
                >
                  {savingNotes ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Saving...
                    </>
                  ) : (
                    "Save Notes"
                  )}
                </button>
              </div>
            </div>
            <div className="scrollable">
              <table
                className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <td></td>
                    {
                      dateHeaders.map((h, index) => {
                        const onHeaderClick = () => {
                          //toggleEditRegister(h);
                          history.push(`/lesson/event/${h.lesson.id}`);
                        };
                        return (
                          <td className={"attendanceHeaderEditingOff"} onClick={onHeaderClick}>
                            <div style={{ textAlign: 'center', fontSize: 14 }}>{index + 1}</div>
                            <div style={{ textAlign: 'center' }}>{h.title}</div>
                          </td>)
                      })
                    }
                  </tr>
                </thead>
                {/* Apply the table body props */}
                <tbody>
                  {attendanceGrid && students.map((student, index) => renderStudentAttendance(student, index))}
                </tbody>
              </table>
            </div>
          </>)
        }
      </>
    )
  }
  return (
    <Container className="py-2 py-lg-4">
      <Row className="justify-content-center">
        <Col>
          <Card className="h-100 shadow-sm">
            <Card.Header className="d-flex align-items-center gap-2">
              <h2 className="mb-0">Event Register</h2>
            </Card.Header>
            <Card.Body className="p-3" style={{ overflowX: 'auto' }}>
              {renderBody()}
            </Card.Body>
            <Card.Footer className="text-muted">

            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  );

};

export default EventAttendance;